var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "statical-box-cla" },
    [
      _c("bgChar", { attrs: { title: "设备总数" } }, [
        _vm._v(_vm._s(_vm.dealNumber(50000)))
      ]),
      _vm._v(" "),
      _c("bgChar", { attrs: { title: "接口调用数" } }, [
        _vm._v(_vm._s(_vm.dealNumber(40000)))
      ]),
      _vm._v(" "),
      _c("bgChar", { attrs: { title: "平台应用数" } }, [
        _vm._v(_vm._s(_vm.dealNumber(50000)))
      ]),
      _vm._v(" "),
      _c("bgChar", { attrs: { title: "平台开发数" } }, [
        _vm._v(_vm._s(_vm.dealNumber(40000)))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca4c934a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca4c934a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/dashboard/statistical/statistical.vue
// module id = null
// module chunks = 